// Centralized ESP Data for consistent faculty and specialty definitions
// This file ensures both admin panel and user interface use identical data

export const faculties = [
  { id: 'science', label: 'Science & Technology', icon: 'science' },
  { id: 'engineering', label: 'Engineering', icon: 'engineering' },
  { id: 'medicine', label: 'Medicine & Health', icon: 'medical_services' },
  { id: 'business', label: 'Business & Management', icon: 'business' },
  { id: 'law', label: 'Law & Politics', icon: 'gavel' },
  { id: 'education', label: 'Education & Psychology', icon: 'school' },
  { id: 'islamic', label: 'Islamic Sciences', icon: 'mosque' },
  { id: 'arts', label: 'Arts & Humanities', icon: 'palette' },
  { id: 'media', label: 'Media & Communication', icon: 'media_bluetooth_on' },
  { id: 'agriculture', label: 'Agriculture & Veterinary', icon: 'agriculture' },
  { id: 'other', label: 'Other Specialized', icon: 'more_horiz' },
];

export const specialtiesData = {
  science: ['Computer Science', 'Physics', 'Chemistry', 'Biology', 'Mathematics', 'Engineering Physics'],
  engineering: ['Mechanical Engineering', 'Electrical Engineering', 'Civil Engineering', 'Chemical Engineering', 'Computer Engineering', 'Industrial Engineering'],
  medicine: ['Medicine', 'Nursing', 'Pharmacy', 'Dentistry', 'Physiotherapy', 'Medical Laboratory Sciences'],
  business: ['Business Administration', 'Accounting', 'Finance', 'Marketing', 'Human Resources', 'Management Information Systems'],
  law: ['Law', 'Political Science', 'International Relations', 'Public Administration', 'Criminal Justice', 'Diplomacy'],
  education: ['Education', 'Psychology', 'Counseling', 'Special Education', 'Educational Technology', 'Child Development'],
  islamic: ['Islamic Law', 'Islamic Theology', 'Islamic History', 'Arabic Language', 'Islamic Economics', 'Islamic Education'],
  arts: ['Literature', 'History', 'Philosophy', 'Fine Arts', 'Languages', 'Cultural Studies'],
  media: ['Journalism', 'Public Relations', 'Digital Media', 'Film Studies', 'Communication Studies', 'Advertising'],
  agriculture: ['Agriculture', 'Veterinary Medicine', 'Animal Science', 'Plant Science', 'Food Science', 'Agricultural Economics'],
  other: ['Architecture', 'Urban Planning', 'Environmental Science', 'Tourism', 'Sports Science', 'Fashion Design'],
};

export const academicLevels = [
  { id: 'bachelor_1', label: 'Bachelor Year 1', icon: 'school' },
  { id: 'bachelor_2', label: 'Bachelor Year 2', icon: 'school' },
  { id: 'bachelor_3', label: 'Bachelor Year 3', icon: 'school' },
  { id: 'master_1', label: 'Master Year 1', icon: 'school' },
  { id: 'master_2', label: 'Master Year 2', icon: 'school' },
  { id: 'phd', label: 'PhD', icon: 'school' },
];

// Helper function to get faculty by ID
export const getFacultyById = (id) => {
  return faculties.find(faculty => faculty.id === id);
};

// Helper function to get specialties by faculty ID
export const getSpecialtiesByFacultyId = (facultyId) => {
  return specialtiesData[facultyId] || [];
};

// Helper function to get academic level by ID
export const getAcademicLevelById = (id) => {
  return academicLevels.find(level => level.id === id);
};

// Helper function to validate faculty ID
export const isValidFacultyId = (id) => {
  return faculties.some(faculty => faculty.id === id);
};

// Helper function to validate specialty for a faculty
export const isValidSpecialtyForFaculty = (facultyId, specialty) => {
  const specialties = specialtiesData[facultyId] || [];
  return specialties.includes(specialty);
};

// Helper function to validate academic level ID
export const isValidAcademicLevelId = (id) => {
  return academicLevels.some(level => level.id === id);
};
